const $inject = ['APP_CONFIG'];

const apiService = (APP_CONFIG) => {
  const service = {
    getUrl: getUrl,
    isMockActive: isMockActive
  };

  return service;

  function getUrl(name, slugs) {
    return isMockActive(name) ? getFullUrl(APP_CONFIG.API[name].mockUrl, slugs) : getFullUrl(APP_CONFIG.API[name].url, slugs);
  }

  function getFullUrl(apiUrl, slugs) {
    if(_.isFunction(apiUrl)) {
      return apiUrl(slugs);
    }

    return apiUrl;
  }

  function isMockActive(name) {
    return APP_CONFIG.MOCK_DATA.active || APP_CONFIG.API[name].useMockUrl;
  }
};

apiService.$inject = $inject;

export default apiService;


// WEBPACK FOOTER //
// ./src/services/apiService.js